import React from 'react'
import Illustration from 'assets/image/about-us/vision-mission.png'

const Mission = () => {
  return (
    <div className="bg-[#F7F8FA]">
      <section
        className={`
        flex flex-col justify-between items-center px-6 m-auto left-0 right-0 max-w-[1024px] gap-y-10
        sm:flex-row
        py-[40px]
        md:py-[88px] md:px-14  
        xl:px-[120px] xl:max-w-[1440px] 
      `}
      >
        <div className="md:max-w-[300px] lg:max-w-[380px] xl:max-w-[513px]">
          <img src={Illustration} alt="" />
        </div>
        <div className="flex-1 md:ml-[90px] md:order-last order-first">
          <div>
            <div className="bg-neutral-30 py-3 px-5 w-fit">
              <h1 className="font-bold text-xs md:text-sm text-[#003DA6] leading-[150%]">
                OUR VISION
              </h1>
            </div>

            <div className="mt-6">
              <h2 className="font-bold text-[#101838] text-[24px] md:text-[28px]">
                To be the largest Supply Chain Platform for SME Manufacturers across Indonesia
              </h2>
            </div>
          </div>
          <div className="mt-[32px]">
            <div className="bg-neutral-30 py-3 px-5 w-fit">
              <h1 className="font-bold text-xs md:text-sm text-[#003DA6] leading-[150%]">
                OUR MISSION
              </h1>
            </div>

            <div className="mt-6">
              <h2 className="font-bold text-[#101838] text-[24px] md:text-[28px]">
                Bringing value across the Manufacturing Supply Chain in increasing capacity utilization of Manufacturers in Indonesia
              </h2>
              <p className="mt-4 md:mt-6 text-base leading-6 text-[#969FB6] xl:w-[502px]">
                Manuva focuses on creating value throughout the whole customer
                journey on custom-made and ready-made products by digitizing the
                end-to-end supply chain of manufacturing. We believe in
                empowering not disrupting the ecosystem. By creating a more
                visible and connected supply chain, Manuva is able to bring value
                to customers through cheaper price, faster lead times, and better
                quality both for B2B customers and retailers.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Mission
